(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
    const doc = document;
    const root = doc.documentElement;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, char => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[char]);
    const formatMoney = cents => {
      const value = Number(cents || 0) / 100;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: document.documentElement.dataset.currency || 'USD'
      }).format(value);
    };

    let pointerFrame;
    if (!reducedMotion && window.matchMedia('(pointer: fine)').matches) {
      window.addEventListener('pointermove', event => {
        if (pointerFrame) return;
        pointerFrame = requestAnimationFrame(() => {
          const x = event.clientX / window.innerWidth - .5;
          const y = event.clientY / window.innerHeight - .5;
          root.style.setProperty('--pointer-x', x.toFixed(3));
          root.style.setProperty('--pointer-y', y.toFixed(3));
          doc.querySelectorAll('[data-magnetic]').forEach(element => {
            const rect = element.getBoundingClientRect();
            const dx = event.clientX - (rect.left + rect.width / 2);
            const dy = event.clientY - (rect.top + rect.height / 2);
            const distance = Math.hypot(dx, dy);
            if (distance < 130) {
              element.style.setProperty('--magnetic-x', `${dx * .1}px`);
              element.style.setProperty('--magnetic-y', `${dy * .1}px`);
            } else {
              element.style.setProperty('--magnetic-x', '0px');
              element.style.setProperty('--magnetic-y', '0px');
            }
          });
          pointerFrame = null;
        });
      }, { passive: true });
    }

    const header = doc.querySelector('[data-site-header]');
    const progress = doc.querySelector('[data-page-progress]');
    let scrollFrame;
    const onScroll = () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(() => {
        const top = window.scrollY;
        const max = Math.max(doc.documentElement.scrollHeight - window.innerHeight, 1);
        root.style.setProperty('--page-progress', Math.min(top / max, 1).toFixed(4));
        if (header) header.classList.toggle('is-scrolled', top > 12);
        doc.querySelectorAll('[data-parallax]').forEach(element => {
          const rect = element.getBoundingClientRect();
          const center = rect.top + rect.height / 2 - window.innerHeight / 2;
          const strength = Number(element.dataset.parallax || 18);
          element.style.setProperty('--parallax-y', `${Math.max(-strength, Math.min(strength, center / window.innerHeight * -strength))}px`);
        });
        scrollFrame = null;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const revealObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .08 })
      : null;
    doc.querySelectorAll('.reveal').forEach(element => {
      if (revealObserver) revealObserver.observe(element);
      else element.classList.add('is-visible');
    });

    const mobileNav = doc.querySelector('[data-mobile-nav]');
    const setMenu = open => {
      if (!mobileNav) return;
      mobileNav.classList.toggle('is-open', open);
      mobileNav.setAttribute('aria-hidden', String(!open));
      doc.body.classList.toggle('menu-open', open);
      doc.querySelectorAll('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded', String(open)));
      if (open) mobileNav.querySelector('a, button, summary')?.focus();
    };
    doc.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => setMenu(!mobileNav?.classList.contains('is-open'))));
    doc.querySelectorAll('[data-menu-close]').forEach(button => button.addEventListener('click', () => setMenu(false)));

    const searchDialog = doc.querySelector('[data-search-dialog]');
    const searchInput = searchDialog?.querySelector('[data-predictive-input]');
    const searchResults = searchDialog?.querySelector('[data-predictive-results]');
    let searchTimer;
    let searchController;
    const setSearch = open => {
      if (!searchDialog) return;
      if (open && !searchDialog.open) searchDialog.showModal();
      if (!open && searchDialog.open) searchDialog.close();
      doc.body.classList.toggle('search-open', open);
      if (open) requestAnimationFrame(() => searchInput?.focus());
    };
    doc.querySelectorAll('[data-search-open]').forEach(button => button.addEventListener('click', () => setSearch(true)));
    doc.querySelectorAll('[data-search-close]').forEach(button => button.addEventListener('click', () => setSearch(false)));
    searchDialog?.addEventListener('click', event => {
      if (event.target === searchDialog) setSearch(false);
    });
    searchDialog?.addEventListener('close', () => doc.body.classList.remove('search-open'));

    const fetchSearch = async query => {
      if (!searchResults || query.length < 2) {
        if (searchResults) searchResults.innerHTML = '';
        return;
      }
      searchController?.abort();
      searchController = new AbortController();
      searchResults.setAttribute('aria-busy', 'true');
      try {
        const url = `${window.PlayBolt.routes.search}?q=${encodeURIComponent(query)}&resources[type]=product,collection,page,article&resources[limit]=8&section_id=predictive-search`;
        const response = await fetch(url, { signal: searchController.signal });
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        searchResults.innerHTML = parsed.querySelector('#shopify-section-predictive-search')?.innerHTML || html;
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.innerHTML = '';
      } finally {
        searchResults.removeAttribute('aria-busy');
      }
    };
    searchInput?.addEventListener('input', event => {
      clearTimeout(searchTimer);
      searchTimer = setTimeout(() => fetchSearch(event.target.value.trim()), 180);
    });

    doc.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = [...gallery.querySelectorAll('[data-product-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      let index = 0;
      const select = nextIndex => {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translateX(${-100 * index}%)`;
        slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', String(i !== index));
          slide.toggleAttribute('inert', i !== index);
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
        thumbs[index]?.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
      };
      gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => select(index - 1));
      gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => select(index + 1));
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
      gallery.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') select(index - 1);
        if (event.key === 'ArrowRight') select(index + 1);
      });
      let touchX;
      gallery.addEventListener('touchstart', event => {
        touchX = event.touches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', event => {
        if (touchX == null) return;
        const delta = event.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 45) select(index + (delta < 0 ? 1 : -1));
        touchX = null;
      }, { passive: true });
      select(0);
    });

    doc.querySelectorAll('[data-product-form]').forEach(form => {
      const dataElement = form.closest('[data-product-root]')?.querySelector('[data-product-json]');
      const productData = dataElement ? JSON.parse(dataElement.textContent) : null;
      const variantInput = form.querySelector('[name="id"]');
      const addButton = form.querySelector('[name="add"]');
      const priceNode = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
      const updateVariant = () => {
        if (!productData) return;
        const values = [...form.querySelectorAll('[data-option-group]')].map(group => group.querySelector('input:checked')?.value);
        const variant = productData.variants.find(item => item.options.every((option, i) => option === values[i]));
        if (!variant) {
          addButton.disabled = true;
          return;
        }
        variantInput.value = variant.id;
        addButton.disabled = !variant.available;
        if (priceNode) {
          const compare = variant.compare_at_price > variant.price ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : '';
          priceNode.innerHTML = `<div class="price${compare ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${compare}</div>`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      form.querySelectorAll('[data-option-group] input').forEach(input => input.addEventListener('change', updateVariant));
    });

    doc.querySelectorAll('[data-quantity]').forEach(quantity => {
      const input = quantity.querySelector('input');
      quantity.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      quantity.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        input.value = Math.min(Number(input.max || 999), Number(input.value || 1) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const toast = doc.querySelector('[data-toast]');
    let toastTimer;
    const showToast = message => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
    };

    const cartDrawer = doc.querySelector('#CartDrawer');
    const renderCart = cart => {
      doc.querySelectorAll('[data-cart-count]').forEach(node => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
      const body = cartDrawer?.querySelector('[data-cart-drawer-body]');
      const subtotal = cartDrawer?.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = `<p>${escapeHtml(window.PlayBolt.strings.empty)}</p>`;
        return;
      }
      body.innerHTML = cart.items.map(item => `
        <div class="cart-drawer__item">
          ${item.image ? `<img src="${escapeHtml(item.image)}&width=160" alt="${escapeHtml(item.title)}" width="80" height="80">` : '<div></div>'}
          <div><strong>${escapeHtml(item.product_title)}</strong><span>${escapeHtml(item.variant_title || '')}</span></div>
          <span>${formatMoney(item.final_line_price)}</span>
        </div>
      `).join('');
    };
    const refreshCart = async openDrawer => {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      renderCart(cart);
      if (openDrawer && cartDrawer && !cartDrawer.open) cartDrawer.showModal();
      return cart;
    };
    doc.querySelectorAll('[data-cart-trigger]').forEach(button => button.addEventListener('click', event => {
      if (!cartDrawer) return;
      event.preventDefault();
      refreshCart(true);
    }));
    doc.querySelectorAll('[data-cart-close]').forEach(button => button.addEventListener('click', () => cartDrawer?.close()));
    cartDrawer?.addEventListener('click', event => {
      if (event.target === cartDrawer) cartDrawer.close();
    });

    doc.addEventListener('submit', async event => {
      const form = event.target.closest('[data-quick-add], [data-product-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const original = button?.innerHTML;
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      try {
        const response = await fetch(window.PlayBolt.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart error');
        await refreshCart(true);
        showToast(window.PlayBolt.strings.added);
      } catch {
        showToast(window.PlayBolt.strings.error);
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (original) button.innerHTML = original;
        }
      }
    });

    const filterToggle = doc.querySelector('[data-filter-toggle]');
    const filters = doc.querySelector('[data-filters]');
    filterToggle?.addEventListener('click', () => {
      const open = filters?.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', String(open));
    });
    doc.querySelector('[data-sort-select]')?.addEventListener('change', event => event.target.form.submit());

    const faqSearch = doc.querySelector('[data-faq-search]');
    faqSearch?.addEventListener('input', event => {
      const query = event.target.value.trim().toLowerCase();
      doc.querySelectorAll('[data-faq-item]').forEach(item => {
        item.hidden = query.length > 1 && !item.textContent.toLowerCase().includes(query);
      });
      doc.querySelectorAll('[data-faq-group]').forEach(group => {
        group.hidden = ![...group.querySelectorAll('[data-faq-item]')].some(item => !item.hidden);
      });
    });

    doc.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('.reveal').forEach(element => element.classList.add('is-visible'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
